import React, { useContext, useEffect, useState } from "react";
import Header from "./header";
import SideBar from "./sidebar";
import Dashboard from "../views/dashboard";
import Home from "../views/home";
import Items from "../views/Items/Items";
import NewItems from "../views/Items/NewItems";
import EditItems from "../views/Items/EditItems";
import Clients from "../views/Items/Clients";
import NewClient from "../views/Items/NewClient";
import { Route, Routes, useNavigate } from "react-router-dom";
import Proxy from "../components/Proxy";
// import smalLogo from '../assets/images/elexpertise-smal2.png';

import ApiJWT from "../components/shared/jwtInterceptor";
import AuthContext from "../components/shared/AuthContext";
import ClientFournisseur from "../views/Items/ClientFournisseur";
import OrganisationProfile from "../views/organisations/OrganisationProfile";
import OrganisationList from "../views/organisations/OrganisationList";
import CurrenciesList from "../views/CurrenciesList";
import TaxesList from "../views/TaxesList";
import { OrgContextProvider } from "../organisation/OrgContext";
import ModeleEmail from "./ModeleEmail";
import SingleModele from "./SingleModele";
import InvoiceModelsList from "../views/InvoiceModelsList";
import Calendar from "../views/calendar/Calendar";
import OrganisationUpdate from "../views/organisations/OrganisationUpdate";
import { useTranslation } from "react-i18next";
import InvoicesList from "../views/invoices/all";

import NewInvoice from "../views/invoice/NewInvoice";
import NewDevis from "../views/devis/NewDevis";
import DevisList from "../views/devis/DevisList";
import FactureAvoirList from "../views/facture-avoir/FactureAvoirList";
import NewFactureAvoir from "../views/facture-avoir/NewFactureAvoir";
import FactureAchatList from "../views/facture-achat/FactureAchatList";
import NewFactureAchat from "../views/facture-achat/NewFactureAchat";
import NewFactureDepense from "../views/facture-depense/NewFactureDepense";
import FactureDepenseList from "../views/facture-depense/FactureDepenseList";
import Tresorie from "../views/Tresorie";
import PlanComptable from "../views/comptable/PlanComptable";
import NewAccount from "../views/comptable/NewAccount";
import EditInvoice from "../views/invoice/EditInvoice";
import InvoiceDetails from "../views/invoice/InvoiceDetails";
import EditInvoiceAchat from "../views/facture-achat/EditInvoiceAchat";
import InvoiceAchatDetails from "../views/facture-achat/InvoiceAchatDetails";
import EcritureComptable from "../views/comptable/EcritureComptable";
import DraftInvoicesList from "../views/invoices/drafts";
import InvoiceDepenseDetails from "../views/facture-depense/InvoiceDepenseDetails";
import EditInvoiceDepense from "../views/facture-depense/EditInvoiceDepense";
import Journal from "../views/comptable/Journal";
import TableTva from "../views/comptable/TableTva";
import UpdateClient from "../views/Items/UpdateClient";
import DevisDetails from "../views/devis/DevisDetails";
import FactureAvoirDetails from "../views/facture-avoir/FactureAvoirDetails";
import NewPiece from "../views/piece/NewPiece";
import ListPieces from "../views/piece/ListPieces";
import PieceDetails from "../views/piece/PieceDetails";
import PieceUpdate from "../views/piece/PieceUpdate";
import ItemDetails from "../views/Items/ItemDetails";
import ClientDetails from "../views/Items/ClientDetails";
import SeeClientDetails from "../views/Items/SeeClientDetails";
import AddBq from "../views/comptable/bq/AddBq";
import BqList from "../views/comptable/bq/BqList";
import BqEdit from "../views/comptable/bq/BqEdit";
import NewMember from "../views/team/NewMember";
import ListMembers from "../views/team/ListMembers";
import UpdateMember from "../views/team/updateMember";
import NotAllowed from "./NotAllowed";
import { APP_VERSION } from "../helpers/constants";

import AddCs from "../views/comptable/cs/AddCs";
import CsList from "../views/comptable/cs/CsList";
import CsEdit from "../views/comptable/cs/CsEdit";
import DevisEdit from "../views/devis/DevisEdit";
import Tickets from "../views/Tickets";
import Cpc from "../views/comptable/Cpc";
import { Bilan } from "../views/comptable/Bilan";
import RlvBqListe from "../views/comptable/RlvBqListe";

import FacturesRecurrentes from "../views/factures-recurrentes/FacturesRecurrentes";
import NewFactureRecurrentes from "../views/factures-recurrentes/NewFactureRecurrentes";
import { EditFactureRecurrente } from "../views/factures-recurrentes/EditFactureRecurrente";
import { BonCommandes } from "../views/bon-commande/BonCommandes";
import { NewBoncommande } from "../views/bon-commande/NewBoncommande";
import { EditBoncommande } from "../views/bon-commande/EditBoncommande";
import { DetailsBoncommande } from "../views/bon-commande/DetailsBoncommande";
import HistoryListe from "../views/historique/HistoryListe";
import Depots from "../views/Items/Depots";
import {
  SidebarProvider,
  useSidebar,
} from "../components/shared/SidebarContext";

// import DataTable from '../views/DataGrid';

function Main({ props }) {
  useEffect(() => {}, []);
  return (
    <SidebarProvider>
      <MainContent />
    </SidebarProvider>
  );
}
  function MainContent() {
     const [t, i18n] = useTranslation();

  const { user, logout } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
    const { collapsed } = useSidebar();

    return loading ? (
      <div class="page">
        <div class="page-main">
          <h4>Loading...</h4>
        </div>
      </div>
    ) : (
      <div className={`page ${collapsed ? "sidebar-collapsed" : ""}`}>
        <div class="page-main">
          {/* app header */}
          <Header />
          {/* end app header */}

          {/* sidebar */}
          <SideBar />

          {/* end sidebar */}

          {/* <!--app-content open--> */}
          <div className="main-content app-content mt-0">
            <div className="side-app">
              {/* <!-- CONTAINER --> */}
              <div
                className="main-container container-fluid"
                style={{ paddingTop: 90 }}
              >
                <Routes>
                  <Route path={`/`} element={<Dashboard />}></Route>
                  <Route path={`/home`} element={<Home />}></Route>

                  <Route
                    path={`/items`}
                    element={
                      <Proxy
                        name={"Article"}
                        description={t(
                          "Ici vous pouvez ajouter et gérer vos produits. Accédez à la liste complète de vos produits en un instant. Simplifiez la gestion de vos produits avec ELMANAGER.",
                        )}
                        add="/items/add"
                        list="/items/list"
                        listDepots="/items/list/depots"
                        nameDepots={t("Dépôts")}
                        id={"articles"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route path={`/items/list`} element={<Items />}></Route>
                  <Route path={`/items/add`} element={<NewItems />}></Route>
                  <Route path="items/list/depots" element={<Depots />}></Route>
                  <Route
                    path={`/items/edit/:id`}
                    element={<EditItems />}
                  ></Route>
                  <Route
                    path={`/items/details/:id`}
                    element={<ItemDetails />}
                  ></Route>
                  <Route
                    path={`/clients`}
                    element={
                      <Proxy
                        name={"Client"}
                        description={t(
                          "L'endroit unique pour créer, gérer, et suivre vos contacts professionnels. Ajoutez facilement de nouveaux clients et accédez à votre liste complète en un clin d'œil. Simplifiez vos affaires avec vos Clients.",
                        )}
                        add="/client/add"
                        list="/clients/list"
                        id={"clients"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/clients/list`}
                    element={<Clients clientType="client" />}
                  ></Route>
                  <Route
                    path={`/client/add`}
                    element={<NewClient clientType={"client"} />}
                  ></Route>
                  <Route
                    path={`/client/edit`}
                    element={<UpdateClient clientType={"client"} />}
                  ></Route>
                  <Route
                    path={`/client/details`}
                    element={<SeeClientDetails clientType={"client"} />}
                  ></Route>
                  <Route
                    path={`/fournisseur/details`}
                    element={<SeeClientDetails clientType={"fournisseur"} />}
                  ></Route>
                  <Route
                    path={`/fournisseurs`}
                    element={
                      <Proxy
                        name={"Fournisseur"}
                        description={t(
                          "L'endroit unique pour créer, gérer, et suivre vos contacts professionnels. Ajoutez facilement de nouveaux fournisseurs et accédez à votre liste complète en un clin d'œil. Simplifiez vos affaires avec vos Fournisseurs..",
                        )}
                        add="/fournisseurs/add"
                        list="/fournisseurs/list"
                        id={"fournisseurs"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/fournisseurs/list`}
                    element={<ClientFournisseur clientType={"fournisseurs"} />}
                  ></Route>
                  <Route
                    path={`/fournisseurs/add`}
                    element={<NewClient clientType={"fournisseurs"} />}
                  ></Route>
                  <Route
                    path={`/fournisseurs/edit`}
                    element={<UpdateClient clientType={"fournisseurs"} />}
                  ></Route>
                  <Route
                    path={`/organisations/list`}
                    element={<OrganisationList />}
                  ></Route>
                  <Route
                    path={`/organisations`}
                    element={
                      <Proxy
                        name={"Organisation"}
                        description={t(
                          "Prenez le contrôle de vos organisations. Dans la section organisations, vous pouvez ajouter facilement vos activités commerciales. en un instant, tout en ayant un accès rapide à la liste complète de vos organisations.",
                        )}
                        add="/organisation_profile"
                        list="/organisations/list"
                        id={"Organisations"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>

                  <Route
                    path={`/bq`}
                    element={
                      <Proxy
                        name={"Compte comptable de la banque"}
                        description={t(
                          "Notre espace dédié permet de créer, modifier, supprimer et visualiser les comptes comptables de la banque en toute simplicité et sécurité",
                        )}
                        add="/bq/add"
                        list="/bq/list"
                        id={"bq"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route path={`/bq/add`} element={<AddBq />}></Route>
                  <Route path={`/bq/list`} element={<BqList />}></Route>
                  <Route path={`/bq/edit/:id`} element={<BqEdit />}></Route>

                  <Route
                    path={`/cs`}
                    element={
                      <Proxy
                        name={"Compte comptable de la caisse"}
                        description={t(
                          "Notre espace dédié permet de créer, modifier, supprimer et visualiser les comptes comptables de la caisse en toute simplicité et sécurité",
                        )}
                        add="/cs/add"
                        list="/cs/list"
                        id={"cs"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route path={`/cs/add`} element={<AddCs />}></Route>
                  <Route path={`/cs/list`} element={<CsList />}></Route>
                  <Route path={`/cs/edit/:id`} element={<CsEdit />}></Route>

                  <Route
                    path={`/organisation_profile`}
                    element={<OrganisationProfile />}
                  ></Route>
                  <Route
                    path={`/organisation/edit`}
                    element={<OrganisationUpdate />}
                  ></Route>
                  <Route
                    path={`/devises`}
                    element={
                      <Proxy
                        name={"Devise"}
                        description={t(
                          "Optez pour la devise qui vous convient le mieux avec notre sélection de choix de devises.",
                        )}
                        add="/devises/list"
                        list="/devises/list"
                        id={"Devises"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/devises/list`}
                    element={<CurrenciesList />}
                  ></Route>
                  <Route
                    path={`/taxes`}
                    element={
                      <Proxy
                        name={"Taxe"}
                        description={t(
                          "Trouvez l'impôt parfait pour vous activités commerciales, avec notre sélection de choix d' impôts.",
                        )}
                        add="/taxes/list"
                        list="/taxes/list"
                        id={"Taxes"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route path={`/taxes/list`} element={<TaxesList />}></Route>
                  <Route path={`/modeles`} element={<ModeleEmail />}></Route>
                  <Route
                    path={`/modele/:id`}
                    element={<SingleModele />}
                  ></Route>
                  <Route
                    path={`/models/invoice`}
                    element={<InvoiceModelsList />}
                  ></Route>
                  <Route path={`/calendar`} element={<Calendar />}></Route>
                  <Route
                    path={`/team`}
                    element={
                      <Proxy
                        name={"Équipe de travail"}
                        description={t(
                          "Ici vous pouvez ajouter et gérer votre équipe. Accédez à la liste des membre d'équipe et créer un nouveau. Simplifiez la gestion de votre équipe avec ELMANAGER.",
                        )}
                        add="/team/add"
                        list="/team/list"
                        id={"équipe"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>

                  <Route path={`/team/add`} element={<NewMember />}></Route>
                  <Route path={`/team/list`} element={<ListMembers />}></Route>
                  <Route
                    path={`/team/modify/:id`}
                    element={<UpdateMember />}
                  ></Route>
                  <Route path={`/not-allowed`} element={<NotAllowed />}></Route>

                  <Route
                    path="/history"
                    element={
                      <Proxy
                        name={t("Historique des actions")}
                        description={t(
                          "Consultez l’historique des actions effectuées dans le système.",
                        )}
                        add="none"
                        list="/history/list"
                        id={"history"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path="/history/list"
                    element={<HistoryListe />}
                  ></Route>

                  <Route
                    path={`/sales/invoices`}
                    element={
                      <Proxy
                        name={t("Facture")}
                        description={t(
                          "Optimisez votre gestion des ventes. Créez et suivez vos factures de vente en un instant, tout en ayant un accès rapide à la liste complète de vos opérations ventes.",
                        )}
                        add="/facture/add"
                        list="/sales/invoices/list"
                        id={"invoices"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/sales/invoices/list`}
                    element={<InvoicesList />}
                  ></Route>
                  <Route path={`/facture/add`} element={<NewInvoice />}></Route>

                  <Route
                    path={`/sales/devis`}
                    element={
                      <Proxy
                        name={t("Devis")}
                        description={t(
                          "Conclure l’affaire. Avec les devis, proposez à vos clients une offre qu’ils ne pourront pas refuser ! Et vous pouvez facilement accéder à la liste de vos devis.",
                        )}
                        add="/devis/add"
                        list="/sales/devis/list"
                        id={"devis"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/sales/devis/list`}
                    element={<DevisList />}
                  ></Route>
                  <Route
                    path={`/devis/edit/:id`}
                    element={<DevisEdit />}
                  ></Route>
                  <Route path={`/devis/add`} element={<NewDevis />}></Route>

                  <Route
                    path={`/sales/factureavoir`}
                    element={
                      <Proxy
                        name={t("Factures d'avoir")}
                        description={t(
                          "Dans la section Factures d’avoir, vous pouvez : Créez et suivez facilement vos factures d’avoir. en un instant, tout en ayant un accès rapide à la liste complète de vos factures.",
                        )}
                        add="none"
                        list="/sales/factureavoir/list"
                        id={"facture_d_avoir"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/sales/factureavoir/list`}
                    element={<FactureAvoirList />}
                  ></Route>
                  <Route
                    path={`/factureavoir/add`}
                    element={<NewFactureAvoir />}
                  ></Route>

                  <Route
                    path={`/achat/factureachat`}
                    element={
                      <Proxy
                        name={t("Factures d'achat liées au stock")}
                        description={t(
                          "Optimisez votre gestion des achats liés au stock. Créez et suivez facilement vos factures d’achats liés au stock\n" +
                            "en un instant, tout en ayant un accès rapide à la liste complète de vos opérations d’achats.",
                        )}
                        add="/factureachat/add"
                        list="/achat/factureachat/list"
                        id={"facture_achat"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/achat/factureachat/list`}
                    element={<FactureAchatList />}
                  ></Route>
                  <Route
                    path={`/factureachat/add`}
                    element={<NewFactureAchat />}
                  ></Route>

                  <Route
                    path={`/depense/facturedepense`}
                    element={
                      <Proxy
                        name={t("Factures de dépenses")}
                        description={t(
                          "Gérez vos dépenses en toute simplicité. Vous pouvez créer et suivre facilement vos factures de dépenses° en un\n" +
                            "instant, tout en ayant un accès rapide à la liste complète de vos dépenses réalisées.",
                        )}
                        add="/facturedepense/add"
                        list="/depense/facturedepense/list"
                        id={"facture_depense"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/depense/facturedepense/list`}
                    element={<FactureDepenseList />}
                  ></Route>
                  <Route
                    path={`/facturedepense/add`}
                    element={<NewFactureDepense />}
                  ></Route>
                  <Route path={`/tresorie`} element={<Tresorie />}></Route>

                  <Route
                    path={`/plancomptable`}
                    element={
                      <Proxy
                        name={t("Plan comptable")}
                        description={
                          "Notre système de gestion du plan comptable vous permet de consulter les transactions passées et de générer facilement le grand livre ainsi que la balance comptable."
                        }
                        add="/plancomptable/add"
                        list="/plancomptable/list"
                        id={"plan_comptable"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/plancomptable/list`}
                    element={<PlanComptable />}
                  ></Route>
                  <Route
                    path={`/plancomptable/add`}
                    element={<NewAccount />}
                  ></Route>
                  <Route
                    path={`/plancomptable/ec`}
                    element={<EcritureComptable />}
                  ></Route>
                  <Route
                    path={`/comptabilite/journal`}
                    element={<Journal />}
                  ></Route>
                  <Route
                    path={`/comptabilite/tvaTable`}
                    element={<TableTva />}
                  ></Route>

                  <Route
                    path={`/invoice/edit/:id`}
                    element={<EditInvoice />}
                  ></Route>
                  <Route
                    path={`/invoice/details/:id`}
                    element={<InvoiceDetails />}
                  ></Route>

                  <Route
                    path={`/devis/details/:id`}
                    element={<DevisDetails />}
                  ></Route>
                  <Route
                    path={`/facture_avoir/details/:id`}
                    element={<FactureAvoirDetails />}
                  ></Route>

                  <Route
                    path={`/invoice/achat/edit/:id`}
                    element={<EditInvoiceAchat />}
                  ></Route>
                  <Route
                    path={`/invoice/achat/details/:id`}
                    element={<InvoiceAchatDetails />}
                  ></Route>

                  <Route
                    path={`/factures_brouillons`}
                    element={<DraftInvoicesList />}
                  ></Route>

                  <Route
                    path={`/invoice/depense/details/:id`}
                    element={<InvoiceDepenseDetails />}
                  ></Route>
                  <Route
                    path={`/invoice/depense/edit/:id`}
                    element={<EditInvoiceDepense />}
                  ></Route>

                  <Route
                    path={`/piece/add`}
                    element={<NewPiece from={"main"} />}
                  ></Route>
                  <Route path={`/piece/list`} element={<ListPieces />}></Route>
                  <Route
                    path={`/piece/details/:id`}
                    element={<PieceDetails />}
                  ></Route>
                  <Route
                    path={`/piece/edit/:id`}
                    element={<PieceUpdate />}
                  ></Route>
                  <Route
                    path={`/piece`}
                    element={
                      <Proxy
                        name={t("Pièce")}
                        description={t(
                          "Optimisez votre gestion des pièces. Créez et suivez facilement vos pièce. en un instant.",
                        )}
                        add="/piece/add"
                        list="/piece/list"
                        id={"piece"}
                        genre={"feminin"}
                      />
                    }
                  ></Route>
                  <Route path="/tickets" element={<Tickets />}></Route>
                  <Route path="/cpc" element={<Cpc />}></Route>
                  <Route path="/bilan" element={<Bilan />}></Route>
                  <Route path="/rlvBq" element={<RlvBqListe />}>
                    {" "}
                  </Route>
                  <Route
                    path={`/factures_recurrentes`}
                    element={<FacturesRecurrentes />}
                  />
                  <Route
                    path={`/facturerecurrente/add`}
                    element={<NewFactureRecurrentes />}
                  />
                  <Route
                    path={`/facturerecurrente/edit/:id`}
                    element={<EditFactureRecurrente />}
                  />
                  <Route
                    path={`/achats/boncommande`}
                    element={
                      <Proxy
                        name={t("Bon de commande")}
                        description={t(
                          "Optimisez votre gestion des achats. Créez et suivez facilement vos bons de commande en un instant, tout en\n" +
                            "ayant un accès rapide à la liste complète de vos opérations d’achats.",
                        )}
                        add="/boncommande/add"
                        list="/achats/boncommande/list"
                        id={"bon_commande"}
                        genre={"masculin"}
                      />
                    }
                  ></Route>
                  <Route
                    path={`/achats/boncommande/list`}
                    element={<BonCommandes />}
                  ></Route>
                  <Route
                    path={`/boncommande/add`}
                    element={<NewBoncommande />}
                  ></Route>
                  <Route
                    path={`/boncommande/edit/:id`}
                    element={<EditBoncommande />}
                  ></Route>
                  <Route
                    path={`/boncommande/details/:id`}
                    element={<DetailsBoncommande />}
                  ></Route>
                </Routes>
              </div>
              {/* <!-- CONTAINER END --> */}
            </div>
          </div>
          {/* <!--app-content close--> */}
        </div>

        {/* <!-- Country-selector modal--> */}

        {/* <!-- FOOTER --> */}
        {/* <footer class="footer">
                    <div class="container">
                        <div class="row ">
                            <div class="col-md-8 col-sm-12" style={{fontSize: 12}}>
                                <img src={smalLogo}
                                     alt="logo" style={{width: '3%', padding: '3px'}}/>
                                {t('Logiciel cloud de comptabilité et commercial en ligne')}
                            </div>
                            <div class="col-md-4 col-sm-12 text-end" style={{fontSize: 12}}>
                                <span  onClick={()=>{navigate('/')}} style={{cursor:"pointer",color:"#3c309b"}}>ElManager</span>. All rights reserved. {APP_VERSION} <br />
                                <span style={{cursor:"pointer",color:"#3c309b"}}>Email :</span> contact@elmanager.ma <br />
                                <span style={{cursor:"pointer",color:"#3c309b"}}>Telephone :</span> +212 6 00 64 99 23 <br />
                                <span style={{cursor:"pointer",color:"#3c309b"}}>Version :</span> 1.1.0 <br />
                            </div>
                            <div class="col-md-4 col-sm-12 text-end" style={{fontSize: 12}}>

                            </div>
                            <div class="col-md-4 col-sm-12 text-end" style={{fontSize: 12}}>
                                
                            </div>
                        </div>
                    </div>
                </footer> */}
        {/* <!-- FOOTER END --> */}
      </div>
    );
  }
export default Main;
